// removed by extract-text-webpack-plugin
module.exports = {"sideBySideInputs":"styles__sideBySideInputs__2Bxn3","sideBySideInputsEverywhere":"styles__sideBySideInputsEverywhere__28ulJ","halfWidth":"styles__halfWidth__gY1MU","halfWidthEverywhere":"styles__halfWidthEverywhere__33kss","oneThirdWidth":"styles__oneThirdWidth__3WIU3","oneThirdWidthEverywhere":"styles__oneThirdWidthEverywhere__3FozQ","twoThirdWidth":"styles__twoThirdWidth__1d4BA","lockButton":"styles__lockButton__3wgWs","marginx":"styles__marginx__EoskB","holder":"styles__holder__1Y8q8","popover":"styles__popover__3yH2Y","cover":"styles__cover__2t6ve"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageResizer/styles.scss
// module id = 894
// module chunks = 0